import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  Component,
  HostListener,
  Inject,
  inject,
  Input,
  OnInit,
  PLATFORM_ID,
  Renderer2,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { currencyModel } from '../../interfaces';
import { HomePageService } from '../../services/home-page/services/home-page.service';
import { SharedService } from '../../services/shared.service';
import { StorageService } from '../../services/storage-services.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() homePage = true;

  public Utilities = inject(HomePageService);
  public translate = inject(TranslateService);
  public sharedService = inject(SharedService);
  public router = inject(Router);
  public activatedRoute = inject(ActivatedRoute);

  private platformId = inject(PLATFORM_ID);
  private renderer = inject(Renderer2);
  private storageService = inject(StorageService);

  private isBrowser: boolean;

  allCurrency: any[] = [];
  isAuthenticated = false;
  loading = true;

  // Use absolute paths for assets to ensure they work in SSR
  logoUrl = '/assets/icons/TravaSkylogo1.svg';
  ImgUrl = '/assets/icons/flags/egy.svg';
  Lang: string = this.translate.currentLang;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.initializeDefaultCurrency();
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.initializeBrowserLogic();
    }
  }

  private initializeDefaultCurrency(): void {
    const defaultCurrency: currencyModel = {
      Currency_Code: 'EGP',
      Image_Url: '/assets/icons/flags/egy.svg',
      ID: 1,
      Currency_Name: 'Egyptian Pound',
      Is_Base_Currency: true,
      rate: 1,
    };
    this.Utilities.selectedCurrency = defaultCurrency;
    this.storageService.setSessionItem('curr', 'EGP');
  }

  private initializeBrowserLogic(): void {
    this.Utilities.getCurrency('EGP');

    this.Utilities.subscription.add(
      this.Utilities.api.currencyApi('EGP').subscribe(
        (res: currencyModel[]) => {
          this.allCurrency = res;

          if (this.Utilities.selectedCurrency.Currency_Code === 'EGP') {
            const egpCurrency = this.allCurrency.find(
              (currency) => currency.Currency_Code === 'EGP',
            );
            if (egpCurrency) {
              this.Utilities.selectedCurrency = egpCurrency;
            }
          }
        },
        (error) => {
          console.error('Error fetching currencies:', error);
        },
      ),
    );

    if (this.isBrowser) {
      const element = this.document.getElementById('exampleElement');
      if (element) {
        this.renderer.setAttribute(element, 'data-example', 'true');
      }
    }
  }

  updateCurrency(currency: currencyModel) {
    this.Utilities.selectedCurrency = currency;
    let currency_ = currency.Currency_Code.replaceAll('"', ' ');
    this.storageService.setSessionItem('curr', currency_);
  }

  updateLang(lang: 'ar' | 'en') {
    if (this.isBrowser) {
      this.storageService.setItem('lang', lang);
    }
    location.reload();
  }

  EgCurr() {
    const egpCurrency = this.allCurrency.find(
      (currency) => currency.Currency_Code === 'EGP',
    );
    if (egpCurrency) {
      this.Utilities.selectedCurrency = egpCurrency;
      this.ImgUrl = '/assets/icons/flags/egy.svg';
      this.storageService.setSessionItem('curr', 'EGP');
    }
  }

  KWCurr() {
    const kwdCurrency = this.allCurrency.find(
      (currency) => currency.Currency_Code === 'KWD',
    );
    if (kwdCurrency) {
      this.Utilities.selectedCurrency = kwdCurrency;
      this.ImgUrl = '/assets/icons/flags/kwt.svg';
      this.storageService.setSessionItem('curr', 'KWD');
    }
  }

  goToContactUs() {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = 'https://flight.travasky.com/contactUs';
    }
  }
}
